module.exports = __webpack_public_path__ + "16fcafe954dd15d1f5b12a4729957cd2.svg";